<template>

        <v-col>
            <v-img class="img-logos" width="100" src="/img/ktronix_logo.svg"></v-img>
        </v-col>
        <v-col>
            <v-img class="img-logos" width="100" src="/img/alkosto-logo.svg"></v-img>
        </v-col>

        <v-col>
            <v-img class="img-logos" width="100" src="/img/alkomprar_logo.svg"></v-img>
        </v-col>
        <v-col>
            <v-img class="img-logos" width="100" src="/img/logo_compensar.png"></v-img>
        </v-col>

        <v-col>
            <v-img class="img-logos" width="100" src="/img/kalley.png"></v-img>
        </v-col>
        <v-col>
            <v-img class="img-logos" width="100" src="/img/ihs.png"></v-img>
        </v-col>
</template>
<script>
export default {
    name: "CarouselImg",
}
</script>